import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'

interface Props {
  reason?: ComponentProgressDetailView['skippedReason']
}

export function SkippedFallback({ reason }: Props) {
  const { t } = useTranslation('coaching')
  const msg = reason === 'previous_null'
    ? t('fallback.skippedPreviousNull')
    : t('fallback.skipped')
  return (
    <div className="rounded-lg bg-gray-50 border border-gray-200 p-6 text-center text-sm text-gray-600">
      {msg}
    </div>
  )
}
